export var NUMBER_ZERO = 0;
export var NUMBER_NEGATIVE_ONE = -1;
export var SORTING_ORDER_MAP = {
  DESC: 'DESC',
  ASC: 'ASC'
};